import Vue from 'vue';
export default Vue.extend({
    props: {
        barColor: {
            type: String,
            default: 'black'
        },
        icon: {
            type: String,
            required: true
        },
        isDisabled: {
            type: Boolean,
            required: false
        },
        isLastKey: {
            type: Boolean,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        onSelectionStart: {
            type: Function
        },
        onSelectionEnd: {
            type: Function
        },
        value: {
            type: Number,
            required: true
        },
        xAxisData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            stepComplete: '0%',
            onMouseUp: () => {
                this.onSelectionEnd();
            }
        };
    },
    computed: {
        iconPositionCorrection() {
            return `calc(-50% + ${this.stepComplete})`;
        }
    },
    beforeDestroy() {
        const element = this.$refs.rangeInput;
        ['mouseup', 'touchend'].forEach(event => {
            if (element) {
                element.removeEventListener(event, this.onMouseUp);
            }
        });
    },
    methods: {
        onRangeInputChange(event) {
            this.onSelectionStart({
                targetColumn: parseInt(event.target.value, 10),
                targetLabel: this.label
            });
            this.stepComplete = `${(parseInt(event.target.value, 10) / this.xAxisData.maxValue) * 100}%`;
        },
        onRangeSelectionChange(event) {
            this.stepComplete = `${(parseInt(event.target.value, 10) / this.xAxisData.maxValue) * 100}%`;
        }
    },
    mounted() {
        const element = this.$refs.rangeInput;
        element.style.setProperty('--background-image', 'url(' + this.icon + ')');
        ['mouseup', 'touchend'].forEach(event => element.addEventListener(event, this.onMouseUp));
    },
    watch: {
        value(newValue) {
            if (!newValue) {
                this.stepComplete = '0%';
            }
        }
    }
});
